import React, { forwardRef, useImperativeHandle, useLayoutEffect, useRef } from "react";
import APTextInput, { APInputProps } from "../../../components/APTextInput";
import { isMobile } from "react-device-detect";
import { useVocabIntl } from "../../../hooks/useVocabTranslation";

interface ExerciseFieldProps extends APInputProps {
}

const APExerciseField = forwardRef<HTMLInputElement, ExerciseFieldProps>(({ error, maxLength, ...props }, ref) => {
  const { getFormattedString } = useVocabIntl();
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => inputRef.current!, []);

  useLayoutEffect(() => {
    if (inputRef.current && isMobile) {
      inputRef.current.setAttribute("type", "text")
      inputRef.current.setAttribute("autocomplete", "one-time-code")
      inputRef.current.setAttribute("autocapitalize", "off")
      inputRef.current.setAttribute("spellcheck", "false")
      inputRef.current.setAttribute("autocorrect", "off")
      inputRef.current.setAttribute("autoCorrect", "off")
    }
  }, [inputRef]);

  return (
    <APTextInput type={isMobile ? "password" : "text"}
                 name="exerciseField"
                 ref={inputRef}
                 variant={"flushed"}
                 id="word-input"
                 key={"word-input"}
                 autoComplete={"false"}
                 autoSave={"false"}
                 autoCorrect={"false"}
                 autoCapitalize={"off"}
                 errorBorderColor="brightOrange.500"
                 fontSize={"lg"}
                 aria-label={getFormattedString('aria-label-word-input')}
                 {...props}
    />
  )
})
export default APExerciseField;